import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../../../actions/navigationActions";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as componentTypes from "../../../../../constants/componentTypes";
import * as windowService from "../../../../../services/windowService";
import * as actions from "../../../../../actions/moduleActions";
import Modal from "../../../../global/generic/Modal";
import Button from "../../../../global/generic/Button";

class ModuleModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedModule: props.params
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModuleModalAction();
    };

    handleNoButtonClick = () => {
        this.handleCloseModalClick();
    };

    handleYesButtonClick = () => {
        if (this.state.selectedModule !== null) {
            let result = windowService.setModule(this.state.selectedModule);
            if (result) {
                this.props.dispatchSaveModuleAction(this.state.selectedModule);
            }
        }
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <Translate className="padding-bottom-10 margin-bottom-12" value="dialog.reallyChangeModule" />
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button onClick={this.handleNoButtonClick} label={<Translate value="general.no" />} />
                <Button onClick={this.handleYesButtonClick} label={<Translate value="general.yes" />} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.moduleChange" />)}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModuleModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_MODULE_MODAL));
        },
        dispatchSaveModuleAction: (module) => {
            dispatch(actions.changeModule(module));
        }
    };
};

export default ModuleModal = connect(mapStoreToProps, mapDispatchToProps)(ModuleModal);
